/**
 * Server-side URL utilities
 * These functions are only used in server components, API routes, and server-side code
 * They validate production environment variables and throw errors if missing
 *
 * Get the application base URL with production validation
 * Throws in production runtime if no deploy URL can be resolved.
 */
import { requireNextPublicSiteUrl } from '@/lib/site-url-required';

function normalizeUrl(url: string): string {
  const trimmed = url.trim();
  const withProtocol = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  return withProtocol.replace(/\/+$/, '');
}

function firstDefinedUrl(...candidates: Array<string | undefined>): string | null {
  for (const candidate of candidates) {
    if (candidate && candidate.trim()) {
      return normalizeUrl(candidate);
    }
  }

  return null;
}

export function getAppUrl(): string {
  requireNextPublicSiteUrl();
  const appUrl = firstDefinedUrl(process.env.NEXT_PUBLIC_APP_URL, process.env.NEXT_PUBLIC_SITE_URL);
  if (!appUrl) {
    throw new Error('NEXT_PUBLIC_SITE_URL missing');
  }
  return appUrl;
}

/**
 * Get the site URL for email links and external references
 * Throws in production runtime if no canonical site URL can be resolved.
 */
export function getSiteUrl(): string {
  return normalizeUrl(requireNextPublicSiteUrl());
}
